import { FC } from 'react';
import { NavHeaderProps } from './NavHeader.types';
import { NavigationListItemStyled, NavigationListStyled, NavStyled } from './NavHeader.style';

const NavHeader: FC<NavHeaderProps> = ({ isAuthenticated }) => {
  return (
    <NavStyled>
      <NavigationListStyled>
        {isAuthenticated && <NavigationListItemStyled>{/* <Link to={'path'}></Link> */}</NavigationListItemStyled>}
      </NavigationListStyled>
    </NavStyled>
  );
};

export default NavHeader;
